import { render, staticRenderFns } from "./writtingDrawer.vue?vue&type=template&id=4d26acec&scoped=true"
import script from "./writtingDrawer.vue?vue&type=script&lang=js"
export * from "./writtingDrawer.vue?vue&type=script&lang=js"
import style0 from "./writtingDrawer.vue?vue&type=style&index=0&id=4d26acec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d26acec",
  null
  
)

export default component.exports